import React from 'react';
import { Field } from 'formik';
import SelectField from './select-field';
import RadioField from './radio-field';
import SwitchField from './switch-field';
import FileField from './file-field';
import InputRange from './input-range';
import DateField from './date-field';
import Typography from '@material-ui/core/Typography';
import AutocompleteField from './autocomplete-field';
import CheckboxField from './checkbox-field';
import TimeField from './time-field';
import TextField from './text-field';

export const DynamicField = (props: any) => {
  if (props.type === 'date') {
    const { initialValue, type, ...datePickerProps } = props;
    return <DateField {...datePickerProps} />;
  }
  if (props.type === 'select') {
    return <SelectField {...props} />;
  }
  if (props.type === 'radio') {
    return <RadioField {...props} />;
  }
  if (props.type === 'switch') {
    return <SwitchField {...props} />;
  }
  if (props.type === 'file') {
    return <FileField {...props} />;
  }
  if (props.type === 'section') {
    return (
      <Typography variant="h6" component="h2" color="textPrimary">
        {props.label}
      </Typography>
    );
  }
  if (props.type === 'input-range') {
    return <Field {...props} variant="outlined" component={InputRange} />;
  }
  if (props.type === 'autocomplete') {
    return <AutocompleteField {...props} />;
  }
  if (props.type === 'checkbox') {
    return <CheckboxField {...props} />;
  }
  if (props.type === 'time') {
    return <TimeField {...props} />;
  }
  if (props.type === 'custom') {
    return props.component;
  }
  return <TextField {...props} />;
};

export default DynamicField;
